export default "__VITE_ASSET__0856a2ca__"